__turbopack_context__.v({
  "active": "iqdJCG_active",
  "activeContent": "iqdJCG_activeContent",
  "content": "iqdJCG_content",
  "favorite": "iqdJCG_favorite",
  "fullWidth": "iqdJCG_fullWidth",
  "shimmer": "iqdJCG_shimmer",
  "tab": "iqdJCG_tab",
  "tabContent": "iqdJCG_tabContent",
  "tabs": "iqdJCG_tabs",
  "text-bar-sweep": "iqdJCG_text-bar-sweep",
});
